import React from 'react'
import {
  InsertDriveFileOutlined,
  PictureAsPdf,
  Image,
  MovieCreation,
  AudioFile,
  Description,
  Code,
  TableChart,
  Archive,
  TextSnippet
} from '@mui/icons-material'

/**
 * Component that displays an appropriate icon based on file media type
 * @param {Object} props - Component props
 * @param {string} props.type - The media type of the file
 * @param {Object} props.style - Optional style object to apply to the icon
 * @returns {JSX.Element} The appropriate icon component
 */
const FileTypeIcon = ({ type, style = {} }) => {
  // Default icon
  if (!type) {
    return (
      <InsertDriveFileOutlined
        fontSize="small"
        color="secondary"
        style={style}
      />
    )
  }

  const fileType = type.toLowerCase()

  // Image files
  if (fileType.includes('image/')) {
    return <Image fontSize="small" color="secondary" style={style} />
  }

  // PDF files
  if (fileType.includes('application/pdf')) {
    return <PictureAsPdf fontSize="small" color="secondary" style={style} />
  }

  // Video files
  if (fileType.includes('video/')) {
    return <MovieCreation fontSize="small" color="secondary" style={style} />
  }

  // Audio files
  if (fileType.includes('audio/')) {
    return <AudioFile fontSize="small" color="secondary" style={style} />
  }

  // Document files (Word, etc.)
  if (
    fileType.includes('application/msword') ||
    fileType.includes(
      'application/vnd.openxmlformats-officedocument.wordprocessingml'
    ) ||
    fileType.includes('application/vnd.oasis.opendocument.text')
  ) {
    return <Description fontSize="small" color="secondary" style={style} />
  }

  // Code files
  if (
    fileType.includes('text/html') ||
    fileType.includes('application/xml') ||
    fileType.includes('application/json') ||
    fileType.includes('text/javascript')
  ) {
    return <Code fontSize="small" color="secondary" style={style} />
  }

  // Spreadsheet files
  if (
    fileType.includes('application/vnd.ms-excel') ||
    fileType.includes(
      'application/vnd.openxmlformats-officedocument.spreadsheetml'
    ) ||
    fileType.includes('application/vnd.oasis.opendocument.spreadsheet')
  ) {
    return <TableChart fontSize="small" color="secondary" style={style} />
  }

  // Archive files
  if (
    fileType.includes('application/zip') ||
    fileType.includes('application/x-rar-compressed') ||
    fileType.includes('application/x-7z-compressed') ||
    fileType.includes('application/x-tar')
  ) {
    return <Archive fontSize="small" color="secondary" style={style} />
  }

  // Text files
  if (fileType.includes('text/plain') || fileType.includes('text/')) {
    return <TextSnippet fontSize="small" color="secondary" style={style} />
  }

  // Default for any other type
  return (
    <InsertDriveFileOutlined fontSize="small" color="secondary" style={style} />
  )
}

export default FileTypeIcon
